import { removeAndAddListeners } from "../general/BuddyFuncs";
import FormSubmit from "./FormSubmit";

export default class AddTeam {
  constructor(
    params = {
      toAddFormClass: null,
      formHolderSelector: "",
      closeBtnSelector: "",
      openBtnSelector: "",
      editTeamMemberSelector: "",
    }
  ) {
    this.toAddFormClass = params.toAddFormClass;

    this.formHolderSelector = params.formHolderSelector;
    this.formHolder = null;

    this.formSelector = `${params.formHolderSelector} form`;
    this.form = null;

    this.closeBtnSelector = params.closeBtnSelector;
    this.closeBtns = null;

    this.openBtnSelector = params.openBtnSelector;
    this.openBtns = null;

    this.editTeamMemberSelector = params.editTeamMemberSelector;
    this.editBtns = null;
  }

  init() {
    this.formClass = new FormSubmit({
      form: this.formSelector,
      justValidate: true,
      submitFunc: (formData) => {
        this.handleSubmitForm(formData);
      },
    });

    this.formClass.init();

    this.formHolder = document.querySelector(this.formHolderSelector);
    this.form = document.querySelector(this.formSelector);
    this.closeBtns = document.querySelectorAll(this.closeBtnSelector);
    this.openBtns = document.querySelectorAll(this.openBtnSelector);

    //add listeners
    this.openBtns.forEach((btn) => {
      removeAndAddListeners(btn, "click", (e) => this.handleOpenFormHolder(e));
    });

    this.closeBtns.forEach((btn) => {
      removeAndAddListeners(btn, "click", (e) => this.handleCloseFormHolder(e));
    });

    this.addListenersToTheButtons();
  }

  addListenersToTheButtons() {
    this.editBtns = document.querySelectorAll(this.editTeamMemberSelector);

    this.editBtns.forEach((btn) => {
      removeAndAddListeners(btn, "click", (e) => this.handleEditInvite(e));
    });
  }

  handleEditInvite(e) {
    e.preventDefault();
    //open the form
    this.open();

    const index = e.currentTarget.dataset.index;

    //get the hidden inputs
    const hiddenInputs = document.querySelectorAll(
      `[data-index="${index}"] input`
    );

    //get and fill in the form items
    this.formClass.form.querySelectorAll("input").forEach((input) => {
      if (input.name !== "index") {
        hiddenInputs.forEach((hiddenInput) => {
          if (input.name === hiddenInput.name.replace("[]", "")) {
            //match so set value
            if (input.type === "radio" || input.type === "checkbox") {
              if (hiddenInput.value === input.value) {
                //is checked
                input.checked = true;
              } else {
                //is not checked
                input.checked = false;
              }
            } else {
              input.value = hiddenInput.value;
            }
          }
        });
      } else {
        //fill in the index
        input.value = index;
      }
    });
  }

  handleSubmitForm(formData) {
    //close the formHolder
    this.close();

    //form data to obj
    const newInvite = {};
    formData.forEach((value, key) => {
      newInvite[key] = value;
    });

    //add or update the teamMembers
    if (newInvite.index) {
      //is update
      this.toAddFormClass.updateTeamMember(newInvite);
    } else {
      //is add
      this.toAddFormClass.addTeamMember(newInvite);
    }
  }

  handleOpenFormHolder(e) {
    e.preventDefault();
    this.open();
  }

  handleCloseFormHolder(e) {
    e.preventDefault();
    this.close();
  }

  clearForm() {
    if (this.form) {
      //clear all values from the inputs
      this.form.querySelectorAll("input").forEach((input) => {
        if (input.type === "radio" || input.type === "checkbox") {
          input.checked = false;
        } else {
          input.value = "";
        }
      });
    }
  }

  open() {
    //add open class
    if (this.formHolder) {
      this.formHolder.classList.add("open");
    }

    //clear inputs
    this.clearForm();
  }
  close() {
    //remove open class
    if (this.formHolder) {
      this.formHolder.classList.remove("open");
    }

    //clear inputs
    this.clearForm();
  }
}
